import { Component, OnInit } from '@angular/core';
import { InfoSpedizioniVini } from '../_classi/InfoSpedizioniVini';
import { VinoItem } from '../_classi/VinoItem';
import { v4 as uuidv4 } from 'uuid';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppoggioService } from '../_servizi/appoggio.service';
import { CantinaService } from '../_servizi/cantina.service';
import { CarrelloViniService } from '../_servizi/carrelloVini.service';
import { LoaderService } from '../_servizi/loader.service';
import { MessageServiceService } from '../_servizi/message-service.service';
import { StepService } from '../_servizi/step.service';
import { StripeService } from '../_servizi/stripe.service';

@Component({
  selector: 'app-step1-vino',
  templateUrl: './step1-vino.component.html',
  styleUrls: ['./step1-vino.component.css']
})
export class Step1VinoComponent implements OnInit {
  checkAbilitato = false;
  abilitato = false;
  abilitatoVenditaVino = false;
  nonabilitatoMsg = '';

  isLoading: Subject<boolean> = this.loaderService.isLoading;

  codiceForm: any;
  idVino: any;
  linguaCorrente: string;

  ricercaFatta = false;
  cantina: any;
  loading = false;

  vino: VinoItem = null;
  vinoSelezionato = null;
  denominazione = null;

  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService,
    public loaderService: LoaderService,
    private stepService: StepService,
    private cantinaService: CantinaService,
    public carrelloService: CarrelloViniService,
    private messageService: MessageServiceService,
    private appoggioService: AppoggioService,
    private stripeService: StripeService,
  ) {
    this.stepService.currentStep = 1;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.codiceForm = params.get('cantina');
      this.idVino = params.get('vino');
      this.linguaCorrente = params.get('lingua');

      this.translate.use(this.linguaCorrente);

      this.controllaCantina(this.codiceForm);

      let idCookie = params.get('idCookie');
      if (idCookie && idCookie !== 'null' && idCookie !== undefined && idCookie !== 'undefined') {
        this.messageService.setIdCookie(idCookie);
      } else {
        idCookie = uuidv4();
        this.messageService.sendIdCookie(idCookie);
        this.messageService.setIdCookie(idCookie);
      }
    });
  }

  controllaCantina(codiceForm): void {
    this.loading = true;
    this.cantinaService.getStato(codiceForm)
      .subscribe(result => {
        this.checkAbilitato = true;
        if (result && result.length > 0) {
          const cantina = result[0];
          this.denominazione = cantina.denominazione;

          if (
            (cantina['wineclub_azione'] === '1' && cantina['wineclub_prova'] === '0') ||
            (cantina['wineclub_azione'] === '1' && cantina['wineclub_prova'] === '1' && moment(cantina['wineclub_scadenza']).isAfter(moment(), 'day'))
          ) {
            this.abilitatoVenditaVino = true;
          }
          this.abilitato = true
          this.appoggioService.setCodiceForm(codiceForm);
          if (cantina['infoStripe'] != null) {
            const infoStripe = {
              abilitatoAccount: cantina['infoStripe']['abilitatoAccountStripe'] === '1' ? true : false,
              abilitatoProduzione: cantina['infoStripe']['abilitatoProduzione'] === '1' ? true : false,
              api_key: cantina['infoStripe']['abilitatoProduzione'] === '1' ? cantina['infoStripe']['apiKeyStripeProduzione'] : cantina['infoStripe']['apiKeyStripeTest'],
              endpoint_secret: cantina['infoStripe']['abilitatoProduzione'] === '1' ? cantina['infoStripe']['endpointSecretProduzione'] : cantina['infoStripe']['endpointSecretTest']
            }
            this.stripeService.setInfoStripe(infoStripe);
          } else {
            this.stripeService.setInfoStripe(null);
          }

          this.appoggioService.setColoriIframe(cantina);

          this.cantinaService.getVinoById(this.idVino, this.codiceForm, this.linguaCorrente)
            .subscribe(result => {
              const info = new InfoSpedizioniVini(result['infoSpedizioniSconti']);
              this.cantinaService.setInfoSpedizioniSconti(info);
              this.ricercaFatta = true;
              if (result && result['vino']) {
                this.vino = new VinoItem(result['vino']);
                this.vinoSelezionato = this.vino;
              } else {
                this.vino = null;
              }
            });

        } else {
          this.abilitato = false;
          this.abilitatoVenditaVino = false;
          this.nonabilitatoMsg = 'nonAbilitato';
        }
        setTimeout(() => {
          this.loading = false;
        }, 2000)
      });
  }

  selezionaVino(obj) {
    this.vinoSelezionato = obj.vino;
  }
}
